import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTemplatesList } from '../../../../api/getApi'
import { updateTemplatesList, clearTemplatesList, updateFilters } from '../../../../redux/vacancyManager/vacancyManager.action'
import useInfiniteScroll from '../../../../hooks/useInfiniteScroll'
import { objToQueryConverter } from '../../../../helpers/apiHelper'
import { vacancyTemplateDataHelper } from '../../../../helpers/vacancyTemplatesManager.helper'
import WithPreloader from '../../../../HOC/WithPreloader'
import VacancyManagerTemplatesList from './VacancyManagerTemplatesList'
import styles from './VacancyManagerTemplatesList.module.scss'
import Input from '../../../../UI/Input/Input'
import useInput from '../../../../hooks/useInput'
import useDebounce from '../../../../hooks/useDebounce'



const VacancyManagerTemplatesListHeader = () => {
    const dispatch = useDispatch()
    const { value, onChange } = useInput('')
    const { templateType, vacancyType, count, filters } = useSelector(({ vacancies }) => vacancies)
    const templatefilters = { vacancy_type: vacancyType, template_type: templateType }
    const debounceValue = useDebounce(value, 500)

    const { loading, nextPage, handleScroll } = useInfiniteScroll(
        getTemplatesList,
        updateTemplatesList,
        vacancyTemplateDataHelper,
        objToQueryConverter({ ...filters, ...templatefilters }),
        clearTemplatesList
    )

    useEffect(() => {
        const search = debounceValue.trim()
        dispatch(updateFilters({ search }))
        // eslint-disable-next-line
    }, [debounceValue, dispatch])

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.header_nav}>
                    All templates ({count})
                </div>

                <div className={styles.input}>
                    <Input theme="search" value={value} onChange={onChange} />
                </div>
            </div>
            <WithPreloader
                size={150}
                component={VacancyManagerTemplatesList}
                type="magnifier"
                loading={nextPage ? loading : null}
                isActive={nextPage === 1 && loading}
                handleScroll={handleScroll}
            />
        </div>

    )
}

export default VacancyManagerTemplatesListHeader